import { AppliedVoucher } from 'network/response/ICart';
import { getFormattedPrice } from 'utils/price.util';

export const getDiscountAmount = (appliedPromo: AppliedVoucher) =>
  getFormattedPrice(
    {
      value: appliedPromo.value,
      currencyIso: appliedPromo.currency.isocode,
      currencyName: appliedPromo.currency.name,
    },
    false,
    true,
    true
  );
